// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import '@/utils/permission.js'; //路由拦截器，控制路由表的js文件
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import moment from 'moment'; //时间过滤器
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2'; //复制功能
import Fragment from 'vue-fragment'; //解决element侧边栏折叠后显示文字问题
import App from './App';
import router from './router';
import store from './store/vuex.js'; //vuex

import Print from 'vue-print-nb'
Vue.use(Print); //注册

//导入所有api，注册全局实例
import axios from './api/index.js';
Vue.prototype.$http = axios

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(Fragment.Plugin)
Vue.use( VueClipboard )

Vue.prototype.ServerUrl = 'http://desktop-vl3jsds:807'

//用户缓存
Vue.prototype.UserData = JSON.parse(localStorage.getItem('UserData'))

//时间过滤 方法
Vue.use(require('vue-moment'));
Vue.prototype.moment = moment

Vue.filter('dateYMDFormat',function(dateStr,pattern='YYYY-MM-DD'){  //年月日
  return moment(dateStr).format(pattern);
})
Vue.filter('dateYMDHMSFormat',function(dateStr,pattern='YYYY-MM-DD HH:mm:ss'){  //年月日 时分秒
  return moment(dateStr).format(pattern);
})

// 防抖处理 -- 最后执行
const on = Vue.prototype.$on
Vue.prototype.$on = function (event, func) {
  let timer
  let newFunc = func
  if (event === 'click') {
    newFunc = function () {
      clearTimeout(timer)
      timer = setTimeout(function () {
        func.apply(this, arguments)
      }, 500)
    }
  }
  on.call(this, event, newFunc)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,   //route: router  简写
  components: { App },
  template: '<App/>',
  store  //引用vuex
})
